import { EmptyStateCard } from '@components/UI/EmptyStateCard/EmptyStateCard.component';
import useMobileDetector from '@shared/hooks/useMobileDetector';
import { useTranslationHelper } from '@shared/hooks/useTranslationsHelper';
import { MdcCircularProgress, MdcGrid } from 'ids-wc/dist/react/components';
import { ListHeader } from './ListHeader.component';
import { IRISPaymentHistoryItem } from './models/IRISPaymentHistoryDTO.model';

import styles from './IRISPaymentHistory.module.css';
import { ListItem } from './ListItem.component';
import { ListItemMobile } from './ListItemMobile.component';
import { useState } from 'react';
import AMODebtorNumberDrawer from './AMODebtorNumberDrawer.component';

interface IRISPaymentHistoryProps {
  data?: IRISPaymentHistoryItem[];
  loading?: boolean;
}

export const List = (props: IRISPaymentHistoryProps) => {
  const isMobile = useMobileDetector();

  const [drawerState, setDrawerState] = useState<{
    data: string;
    isOpen: boolean;
  } | null>(null);

  const onDrawerClose = () => {
    setDrawerState(null);
  };

  const onPaymentSelect = (data: string) => {
    if (!data) {
      console.error('Invalid data', data);
      return;
    }

    setDrawerState({ data, isOpen: true });
  };

  const { data, loading } = props;

  if (loading) {
    return <MdcCircularProgress color="primary" className="mb-2" indeterminate size="lg" labelAria="loading" />;
  }

  if (!data || data.length === 0) return <EmptyState />;

  return (
    <MdcGrid row className={styles['clea-cert-list']}>
      <MdcGrid col={12}>
        {!isMobile && <ListHeader />}

        {data.map((payment, index) =>
          isMobile ? (
            <ListItemMobile
              key={`${payment.amount}-${payment.rfcode}-${index}`}
              payment={payment}
              onSelect={onPaymentSelect}
            />
          ) : (
            <ListItem
              key={`${payment.amount}-${payment.rfcode}-${index}`}
              payment={payment}
              onSelect={onPaymentSelect}
            />
          )
        )}
      </MdcGrid>

      <AMODebtorNumberDrawer
        isOpen={Boolean(drawerState?.isOpen)}
        amoDebtorNumber={drawerState?.data || ''}
        onClose={onDrawerClose}
      />
    </MdcGrid>
  );
};

const EmptyState = () => {
  const { t } = useTranslationHelper('IRISPaymentHistory');

  return (
    <MdcGrid col={12}>
      <EmptyStateCard type="list" title={t('noPaymentHistory')} description={t('noPaymentHistoryExplainer')} />
    </MdcGrid>
  );
};
